export default {
  entityId: 'entityId', // surveys and templates @sinslav
  entityType: 'entityType', // surveys and templates @sinslav
  surveyListPageNumber: 'surveyListPageNumber',
  surveyListTabName: 'surveyListTabName',
  previewPageNumber: 'previewPageNumber',
  questionId: 'questionId',
  surveyUuid: 'surveyUuid',
  sectionName: 'sectionName',
  responseId: 'rid',
  caseId: 'cid',
  ticketId: 'tid',
  questionItemId: 'qid',
  optionUuid: 'ouuid',
  followingResponseUuid: 'following',
  headerCustomizer: 'header-customizer',
  surveyTemplateListPageNumber: 'surveyTemplateListPageNumber',
  errorType: 'errorType',
};
